import React from 'react';
import ControlButton from '../ControlButton/ControlButton';
import { VectorSqaureIcon } from '@Components/icons/VectorSquare';
import { usePolygonDraw } from '../../../usePolygonDraw';

interface EsriPolygonControlProps {
	onPolygonComplete?: (polygon: GeoJSON.Feature<GeoJSON.Polygon>) => void;
}

const EsriPolygonControl: React.FC<EsriPolygonControlProps> = ({
	onPolygonComplete,
}) => {
	const { isActive, startDrawing, cancelDrawing } =
		usePolygonDraw(onPolygonComplete);

	return (
		<ControlButton
			actions={[
				{
					id: 'draw-polygon',
					label: 'Draw Polygon',
					icon: <VectorSqaureIcon />,
					onClick: isActive ? cancelDrawing : startDrawing,
					dataCy: 'draw-polygon',
				},
			]}
			active={isActive}
			dataCy="polygon-control"
		/>
	);
};

export default EsriPolygonControl;
